import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { chartsReponse, userStatistics } from '../models/statistics.model';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  private url = environment.api; 
  private token = localStorage.getItem('token');
  private user = localStorage.getItem('id');

  constructor(private httpClient: HttpClient) {}

   userStatistics() {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${this.token}` 
      });
      return this.httpClient.get<userStatistics>(this.url + `/statistics/user/${this.user}`, { headers });
    }

    userCharts() {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${this.token}` 
      });
      return this.httpClient.get<chartsReponse>(this.url + `/statistics/charts/${this.user}`, { headers });
    }
}
